import React from 'react'
import { FaLinkedin, FaGithub } from "react-icons/fa";
import { FaSquareBehance } from "react-icons/fa6";




const HeaderLinks = () => {
    return (
        <div className='dashes'>
            <div className='header__links'>
                <a className='header__link' href="https://www.linkedin.com/in/mohamed-metwally-355969248/" target='_blank' rel='noreferrer'> <span><FaLinkedin /></span> <span className='LS'>Linked In</span></a>
                <a className='header__link' href="https://github.com/Mo-metwally" target='_blank' rel='noreferrer'> <span><FaGithub /> </span> <span className='LS'>GitHub</span></a>
                <a className='header__link' href="https://www.behance.net/mohamedmetwally29" target='_blank' rel='noreferrer'> <span><FaSquareBehance /></span> <span className='LS'>Behance</span></a>
            </div>
        </div>
    )
}

export default HeaderLinks